<template>
  <div class="container_box">
    <Tabs v-model="pageParams.auditStatus" :animated="false" class="tabs_styles" @on-click="search()">
      <TabPane v-for="item in statusList" :label="item.title" :name="item.value.toString()"></TabPane>
    </Tabs>
    <!--头部筛选区域-->
    <div class="filter_box">
      <Form ref="pageParams" :model="pageParams" :label-width="labelWidth" @submit.native.prevent>
        <Row type="flex" :gutter="gutterItem">
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1003857')" prop="ruleName">
              <Select v-model="pageParams.ruleName" filterable :placeholder="$t('key1003858')">
                <Option v-for="(item,index) in subsidyRulesList" :key="index" :value="item">{{ item }}</Option>
              </Select>
            </Form-item>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1001180')">
              <Date-picker
                type="datetimerange"
                class="wid100P"
                @on-clear="resetDate"
                @on-change="getDateValue"
                :clearable="true"
                :options="dateOptions"
                format="yyyy-MM-dd"
                placement="bottom-end"
                :placeholder="$t('key1000360')"
                :value="createTime">
              </Date-picker>
            </Form-item>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <dropDownFilter
              :transfer="false"
              ref="dropDownFilter"
              inputType="textarea"
              :selectStyle="{width: '110px'}"
              :dropDownInputList="dropDownInputList"
              :defaultSelectValue="defaultSelectValue"
              @changeInput="changeInput"
              @updateInputValue="updateInputValue">
            </dropDownFilter>
          </Col>
          <Col style="min-width: 200px;" push="1">
            <Button @click="reset" icon="md-refresh" class="mr10">{{ $t('key1000109') }}</Button>
            <Button type="primary" @click="search" icon="md-search">{{ $t('key1000361') }}</Button>
          </Col>
        </Row>
      </Form>
    </div>
    <!--功能按钮操作区域-->
    <div class="operation_box">
      <!--批量审核-->
      <Button type="primary" class="mr15" @click="batchAuditBtn"
        v-if="(pageParams.auditStatus === '0' || pageParams.auditStatus === '1') &&
         (getPermission('ymsPickupOrder_batchSubsidyAudit'))">{{ $t('key1003204') }}</Button>
      <!--导出数据-->
      <Dropdown transfer @on-click="changeExportBtn" v-if="getPermission('ymsPickupOrder_exportSubsidyAudit')">
        <Button type="primary">
          <span>{{ $t('key1003082') }}</span>
          <Icon type="ios-arrow-down"></Icon>
        </Button>
        <DropdownMenu slot="list">
          <DropdownItem name="1">{{ $t('key1003083') }}</DropdownItem>
          <DropdownItem name="2">{{ $t('key1003084') }}</DropdownItem>
        </DropdownMenu>
      </Dropdown>
    </div>
    <!--列表区域-->
    <div class="table_box">
      <Table
        ref="selection"
        highlight-row
        border
        max-height="510"
        :loading="tableLoading"
        :columns="tableColumns"
        :data="tableData"
        @on-selection-change="getSelectValue"
        @on-sort-change="sortChange">
      </Table>
      <Page
        :transfer="true"
        v-if="!tableLoading"
        :total="total"
        @on-change="changePage"
        show-total
        :page-size="pageParams.pageSize"
        show-elevator
        :current="pageParams.pageNum"
        show-sizer
        @on-page-size-change="changePageSize"
        placement="top"
        :page-size-opts="pageArray">
      </Page>
    </div>
    <!--导出数据字段弹窗-->
    <exportFieldsModal
      ref="exportFields"
      :exportFieldsTitle="$t('key1003082')"
      paramKeyColums="ymsSubsidyAuditHandlerColumns"
      :customFieldExportList="customFieldExportList"
      @exportFieldsDataBtn="exportFieldsDataBtn">
    </exportFieldsModal>
    <!--审核弹窗-->
    <batchAuditModal ref="batchAudit" @updateData="search('update')"></batchAuditModal>
    <!--补贴说明弹窗-->
    <subsidyDescriptionModal ref="subsidyDescription"></subsidyDescriptionModal>
    <!--操作日志弹窗-->
    <commonLogModal
      ref="commonLog"
      logMode="YMS_DISTRIBUTOR"
      :logType="['SUBSIDY_AUDIT_LOG']"
      :columnsKeyList="['operationType']">
    </commonLogModal>
    <!--调整补贴弹窗-->
    <adjustingSubsidiesModal ref="adjustingSubsidies" @updateData="search()"></adjustingSubsidiesModal>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';
import dropDownFilter from "@/components/common/dropDownFilter";
import commonLogModal from "@/components/common/commonLogModal";
import exportFieldsModal from "@/components/common/exportFieldsModal.vue";
import batchAuditModal from "@/views/yms/components/financialManage/batchAuditModal.vue";
import subsidyDescriptionModal from "@/views/yms/components/financialManage/subsidyDescriptionModal.vue";
import adjustingSubsidiesModal from "@/views/yms/components/financialManage/adjustingSubsidiesModal.vue";
import {
  getUserNameByUserId, pageJump, amountHandel, setConfigCharacters, getEnableWarehouseData,
  getWarehouseName, getAllUsersInfo, getDataSetBatchList, getEnumName
} from "@/utils/common";

export default {
  name: "subsidyReview",
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      pageParamsStatus: false,
      statusList: [
        {value: '0', title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000110')},
        {
          value: '1',
          title: (h) => {
            return h('div', [
              h('span', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002944')),
              h('Badge', {
                props: {
                  count: v.reviewedTotal,
                  overflowCount: 999
                }
              })
            ]);
          }
        },
        {value: '2', title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000986')},
        {value: '3', title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001977')}
      ],
      pageParams: {
        ruleName: null, // 规则
        auditStatus: '1', // 0 全部 1待审核 2已审核 3审核不通过
        createdEndTime: null,
        createdStartTime: null,
        orderBy: 'createdTime', // 默认按照创建时间降序排序
        pageNum: 1,
        pageSize: 15,
        supplierMerchantIds: '',
        supplierPickupOrderNumbers: '',
        trackingNumberList: '',
        upDown: 'down'
      },
      createTime: [],
      total: 0,
      tableColumns: [],
      tableData: [],
      selectTableData: [],
      exportType: '1',
      customFieldExportList: [
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000929'),
          titleKey: 'basicInfoColums',
          selectList: [], // 选中导出字段的key
          checkBoxList: [
            {paramKey: 'supplierPickupOrderNumber', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001775')},
            {paramKey: 'logisticsMode', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003840')},
            {paramKey: 'logisticsCostStr', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003841')},
            {paramKey: 'subsidyAmountStr', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003675')},
            {paramKey: 'ruleName', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003842')},
            {paramKey: 'auditStatus', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003445')},
            {paramKey: 'ymsWarehouseName', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002390')},
            {paramKey: 'supplierMerchantId', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001098')},
            {paramKey: 'trackingNumber', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003698')},
            {paramKey: 'ymsPickupOrderWeight', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003843')},
            {paramKey: 'skuTotal', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003844')},
            {paramKey: 'deliveryEfficiency', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003845')},
            {paramKey: 'createdTime', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002159')},
            {paramKey: 'pickupTime', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003660')},
            {paramKey: 'storageTime', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003846')},
            {paramKey: 'pickingEndTime', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003847')},
            {paramKey: 'updatedBy', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003848')},
            {paramKey: 'updatedTime', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002160')}
          ]
        }
      ],
      subsidyRulesList: [],
      dropDownInputList: [
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001775'), value: 1, placeholder: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003849'), parameterKey: 'supplierPickupOrderNumbers'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003698'), value: 2, placeholder: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003850'), parameterKey: 'trackingNumberList'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001098'), value: 3, placeholder: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003851'), parameterKey: 'supplierMerchantIds'}
      ],
      defaultSelectValue: 1,
      warehouseList: [],
      reviewedTotal: 0,
      userInfoList: {},
      enumData: []
    };
  },
  computed: {
    filterKeyList() {
      let parameterKeyList = this.dropDownInputList.map((item) => {
        return item.parameterKey;
      });
      return parameterKeyList;
    }
  },
  created() {
    this.initFun();
  },
  methods: {
    // 初始化接口数据
    initFun() {
      let v = this;
      v.warehouseList = [];
      (async () => {
        let enumKeyList = ['YmsPickupOrderAuditStatusCoreEnum', 'TransportTypeEnum'];
        v.enumData = await getDataSetBatchList(enumKeyList);
        await getEnableWarehouseData(1).then((data) => {
          v.warehouseList = data;
        });
        await v.getRuleNameData();
        await getAllUsersInfo().then((data) => {
          v.userInfoList = data;
        });
        await v.search('update');
      })();
    },
    // 重置按钮
    reset() {
      let v = this;
      v.$refs['pageParams'].resetFields();
      v.createTime = [];
      v.resetDate();
      v.changeInput(1);
      v.getList();
    },
    // 查询按钮
    search(value) {
      this.pageParams.pageNum = 1;
      this.getList(value);
    },
    // 参数处理
    handleParameter() {
      let v = this;
      let params = Object.assign({}, v.pageParams);
      params.auditStatus = Number(v.pageParams.auditStatus);
      for (let key in params) {
        if (v.filterKeyList.includes(key)) {
          params[key] = v.sepCommasFn(params[key], [',', '，', '\n']);
        }
      }
      return params;
    },
    // 列表查询的方法
    getList(value) {
      let v = this;
      v.optionBtnWidth = [];
      v.tableData = [];
      v.total = 0;
      v.selectTableData = [];
      if (v.getPermission('ymsPickupOrder_querySubsidyAudit')) {
        v.tableLoading = true;
        v.axios.post(api.post_ymsPickupOrder_querySubsidyAudit, v.handleParameter()).then(response => {
          if (response.data.code === 0) {
            let data = response.data.datas;
            v.$refs['selection'].selectAll(false);
            if (data) {
              v.tableData = data.list || [];
              v.total = data.total;
              if (v.pageParams.auditStatus === '1' && value === 'update') {
                v.reviewedTotal = data.total;
              }
              v.updateTableDom('selection');
            }
          } else {
            v.tableLoading = false;
          }
        });
      } else {
        v.gotoError();
      }
    },
    // 获取列表勾选的数据
    getSelectValue(value) {
      this.selectTableData = value;
    },
    // 选择导出数据类型  1 按选中导出 2 按查询结果导出
    changeExportBtn(value) {
      this.exportType = value;
      if (value === '1') {
        if (this.selectTableData.length <= 0) {
          this.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003077'));
          return false;
        }
      } else {
        if (this.tableData.length <= 0) {
          this.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003078'));
          return false;
        }
      }
      this.$refs['exportFields'].getExportFieldsSetting();
    },
    // 导出数据
    exportFieldsDataBtn() {
      let v = this;
      let query = v.handleParameter();
      if (v.exportType === '1') {
        query.supplierPickupOrderNumberList = v.selectTableData.map((item) => {
          return item.supplierPickupOrderNumber;
        });
      } else {
        query.supplierPickupOrderNumberList = [];
      }
      v.$refs['exportFields'].saveExportFieldsSetting().then((data) => {
        if (data) {
          v.axios.post(api.post_ymsPickupOrder_exportSubsidyAudit, query,
            {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(res => {
            if (res.data.code === 0) {
              v.$refs['exportFields'].exportFieldsModal = false;
              let taskNumber = res.data.datas;
              setTimeout(() => {
                pageJump('/yms.html#/exportTask?operateCode=' + taskNumber, '/yms-core-service', '_blank');
              }, 30);
            }
          });
        }
      });
    },
    // 重置创建时间
    resetDate() {
      this.pageParams.createdStartTime = null;
      this.pageParams.createdEndTime = null;
    },
    // 获取日期返回值
    getDateValue(value) {
      let v = this;
      if (value.length === 0) {
        v.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000356'));
        v.resetDate();
      } else {
        if (!value[0]) {
          v.pageParams.createdStartTime = null;
          v.pageParams.createdEndTime = null;
        } else {
          v.pageParams.createdStartTime = v.$uDate.getUniversalTime(new Date(value[0]).getTime());
          v.pageParams.createdEndTime = v.$uDate.getUniversalTime(new Date(value[1]).getTime());
        }
      }
    },
    // 获取下拉选项筛选条件的值
    updateInputValue(data) {
      this.pageParams[data.key] = data.value;
    },
    // 改变默认下拉选项的值
    changeInput(value) {
      this.defaultSelectValue = value;
      this.$refs.dropDownFilter.inputValue = '';
      this.dropDownInputList.map((item) => {
        if (Object.keys(this.pageParams).includes(item.parameterKey)) {
          this.pageParams[item.parameterKey] = '';
        }
      });
    },
    // 时间排序
    sortChange(data) {
      let obj = {
        desc: 'down',
        asc: 'up'
      };
      this.pageParams.upDown = obj[data.order];
      this.pageParams.orderBy = data.key;
      this.pageParamsStatus = true;
    },
    // 批量审核
    batchAuditBtn() {
      if (this.selectTableData.length > 0) {
        let talg = this.selectTableData.every((item) => {
          return item.auditStatus === 1;
        });
        if (talg) {
          let ymsPickupOrderIds = this.selectTableData.map((item) => {
            return item.ymsPickupOrderId;
          });
          this.$refs['batchAudit'].initBatchAuditData('all', ymsPickupOrderIds);
        } else {
          this.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003852'));
          return false;
        }
      } else {
        this.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003853'));
        return false;
      }
    },
    // 处理列表字段
    handleColumns(value) {
      let v = this;
      let columns = [
        {
          type: 'selection',
          width: 60,
          key: 'selection',
          fixed: 'left',
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001775'),
          key: 'supplierPickupOrderNumber',
          minWidth: 160,
          fixed: 'left',
          align: 'center',
          render(h, params) {
            return h('Alink', {
              props: {
                linkName: params.row.supplierPickupOrderNumber,
                className: 'flex justify-content-center'
              },
              on: {
                AlinkBtn: () => {
                  const {href} = v.$router.resolve({
                    path: '/billLadingManageDetails',
                    query: {
                      ymsPickupOrderId: params.row.ymsPickupOrderId
                    }
                  });
                  window.open(href, '_blank');
                }
              }
            });
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003840'),
          key: 'logisticsMode',
          minWidth: 180,
          align: 'center',
          render(h, params) {
            let deliveryType = params.row.deliveryType; // 发货方式{1YMS物流 2自有物流}
            let transportType = params.row.transportType; // 运输方式{1快递 2上门揽收}
            let text = '-';
            if (deliveryType === 1) {
              let name = getEnumName(v.enumData, 'TransportTypeEnum', transportType, 'number');
              text = `${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001581')}` + ' ' + '-' + ' ' + name;
            } else if (deliveryType === 2) {
              text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001587');
            }
            return h('span', text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003841'),
          key: 'logisticsCostCurrency',
          align: 'center',
          minWidth: 130,
          render(h, params) {
            let text = '-';
            let deliveryType = params.row.deliveryType;
            if (deliveryType === 1) {
              let logisticsCostCurrency = params.row.logisticsCostCurrency;
              let logisticsCost = params.row.logisticsCost;
              if (logisticsCostCurrency && logisticsCost) {
                if (logisticsCost && logisticsCostCurrency) {
                  text = logisticsCost + ' ' + logisticsCostCurrency;
                }
              }
            }
            return h('span', text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003675'),
          key: 'subsidyAmount',
          minWidth: 160,
          align: 'center',
          render(h, params) {
            let subsidyAmount = params.row.subsidyAmount;
            return subsidyAmount ? h('div', {
              class: 'flex align-items-center justify-content-center'
            }, [
              h('div', {class: 'mr10'}, subsidyAmount + ' ' + v.currencyState),
              h('Alink', {
                props: {
                  linkName: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003854')
                },
                on: {
                  AlinkBtn: () => {
                    v.$refs['subsidyDescription'].initSubsidyDescriptionData(params.row.ymsPickupOrderId);
                  }
                }
              })
            ]) : subsidyAmount === 0 ? h('span', subsidyAmount + ' ' + v.currencyState) : h('span', '-');
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003842'),
          key: 'subsidyRule',
          minWidth: 160,
          align: 'center',
          render(h, params) {
            let subsidyRule = params.row.subsidyRule;
            let list = [];
            if (subsidyRule) {
              let subsidyRuleList = subsidyRule.split(',');
              subsidyRuleList.map((item) => {
                list.push(h('p', {class: 'mb5 mt5'}, item));
              });
            }
            return h('div', list);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003445'),
          key: 'auditStatus',
          minWidth: 130,
          align: 'center',
          render(h, params) {
            let auditStatus = params.row.auditStatus; // 1待审核 2已审核 3审核不通过
            let auditRemarks = params.row.auditRemarks || '';
            let text = getEnumName(v.enumData, 'YmsPickupOrderAuditStatusCoreEnum', auditStatus, 'number');
            return h('div', [
              auditStatus === 3 ? h('div', {class: 'flex align-items-center'}, [
                h('span', {
                  style: {
                    color: '#e60b0b'
                  }
                }, text),
                h('Tooltip', {
                  props: {
                    transfer: true,
                    maxWidth: 250,
                    placement: 'top',
                    content: auditRemarks
                  },
                  style: {
                    marginLeft: '5px'
                  }
                },
                [
                  h('Icon', {
                    props: {
                      type: 'md-help-circle',
                      size: 17
                    },
                    style: {
                      cursor: 'pointer',
                      color: '#e60b0b'
                    }
                  })
                ])
              ]) : h('span', text)
            ]);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002390'),
          key: 'warehouseName',
          minWidth: 150,
          align: 'center',
          render(h, params) {
            return h('span', getWarehouseName(v.warehouseList, params.row.ymsWarehouseId));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001098'),
          key: 'supplierMerchantId',
          minWidth: 130,
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003698'),
          key: 'trackingNumber',
          minWidth: 170,
          align: 'center',
          render(h, params) {
            let trackingNumber = params.row.trackingNumber || '-';
            return h('span', trackingNumber);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003843'),
          key: 'ymsPickupOrderWeight',
          minWidth: 130,
          align: 'center',
          render(h, params) {
            let deliveryType = params.row.deliveryType; // 发货方式{1YMS物流 2自有物流}
            let transportType = params.row.transportType; // 运输方式{1快递 2上门揽收}
            let weight = deliveryType === 1 && transportType === 1 ? params.row.ymsPickupOrderWeight + 'KG' : '-';
            return h('span', weight);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003855'),
          key: 'skuTotal',
          minWidth: 140,
          align: 'center',
          render(h, params) {
            let text = params.row.skuTotal || '-';
            return h('span', text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003845'),
          key: 'deliveryEfficiency',
          minWidth: 130,
          align: 'center',
          render(h, params) {
            let deliveryEfficiency = params.row.deliveryEfficiency || 0;
            let num = deliveryEfficiency * 100;
            let text = num ? amountHandel(num) + '%' : '-';
            return h('span', text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002159'),
          key: 'createdTime',
          width: 170,
          align: 'center',
          sortable: 'custom',
          sortType: 'desc',
          render(h, params) {
            return h('span', params.row.createdTime ? v.$uDate.dealTime(params.row.createdTime, 'fulltime') : '');
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003660'),
          key: 'pickupTime',
          width: 170,
          align: 'center',
          sortable: 'custom',
          render(h, params) {
            return h('span', params.row.pickupTime ? v.$uDate.dealTime(params.row.pickupTime, 'fulltime') : '');
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003846'),
          key: 'storageTime',
          width: 170,
          align: 'center',
          sortable: 'custom',
          render(h, params) {
            return h('span', params.row.storageTime ? v.$uDate.dealTime(params.row.storageTime, 'fulltime') : '');
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003847'),
          key: 'pickingEndTime',
          width: 170,
          align: 'center',
          sortable: 'custom',
          render(h, params) {
            return h('span', params.row.pickingEndTime ? v.$uDate.dealTime(params.row.pickingEndTime, 'fulltime') : '');
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003848'),
          key: 'updatedBy',
          minWidth: 140,
          align: 'center',
          render(h, params) {
            return h('div', getUserNameByUserId(params.row.updatedBy, v.userInfoList));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002160'),
          key: 'updatedTime',
          width: 170,
          align: 'center',
          sortable: 'custom',
          render(h, params) {
            return h('span', params.row.updatedTime ? v.$uDate.dealTime(params.row.updatedTime, 'fulltime') : '');
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319'),
          key: 'opts',
          align: 'center',
          width: 200,
          fixed: 'right',
          render(h, params) {
            let auditStatus = params.row.auditStatus; // 1待审核 2已审核 3审核不通过
            let ymsPickupOrderId = params.row.ymsPickupOrderId;
            let subsidyAmount = params.row.subsidyAmount;
            return h('optsButtonList', {
              props: {
                operationList: [
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000401'),
                    show: true,
                    clickFn: () => {
                      const {href} = v.$router.resolve({
                        path: '/billLadingManageDetails',
                        query: {
                          ymsPickupOrderId: params.row.ymsPickupOrderId
                        }
                      });
                      window.open(href, '_blank');
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002867'),
                    show: auditStatus === 1 && v.getPermission('ymsPickupOrder_batchSubsidyAudit'),
                    clickFn: () => {
                      v.$refs['batchAudit'].initBatchAuditData('single', [ymsPickupOrderId]);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003856'),
                    show: auditStatus !== 1 && v.getPermission('ymsPickupOrder_againSubsidyAudit'),
                    clickFn: () => {
                      v.$refs['batchAudit'].initBatchAuditData('again', [ymsPickupOrderId]);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001978'),
                    show: v.getPermission('ymsPickupOrder_updateSubsidyAudit'),
                    clickFn: () => {
                      v.$refs['adjustingSubsidies'].initAdjustingSubsidiesData(ymsPickupOrderId, subsidyAmount);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002478'),
                    show: true,
                    clickFn: () => {
                      v.$refs['commonLog'].initCommonLogData(ymsPickupOrderId);
                    }
                  }
                ]
              },
              on: {
                setWidth(value) {
                  if (value) {
                    v.optionBtnWidth.push(value);
                    params.column.width = Math.max(...v.optionBtnWidth);
                    v.$forceUpdate();
                  }
                }
              }
            });
          }
        }
      ];
      if (value === '1') {
        v.tableColumns = columns.filter((item) => {
          return !['updatedBy', 'updatedTime'].includes(item.key);
        });
      } else {
        v.tableColumns = columns;
      }
    },
    // 获取补贴规则名称数据
    getRuleNameData() {
      let v = this;
      v.axios.get(api.get_ymsPickupOrder_querySubsidyRuleLog).then(response => {
        if (response.data.code === 0) {
          let data = response.data.datas || [];
          if (data.length > 0) {
            v.subsidyRulesList = data;
          }
        }
      });
    }
  },
  watch: {
    pageParamsStatus(value) {
      let v = this;
      if (value) {
        v.getList();
        v.pageParamsStatus = false;
      }
    },
    'pageParams.auditStatus': {
      handler(value) {
        this.handleColumns(value);
      },
      deep: true,
      immediate: true
    }
  },
  components: {
    dropDownFilter,
    exportFieldsModal,
    batchAuditModal,
    subsidyDescriptionModal,
    commonLogModal,
    adjustingSubsidiesModal
  }
};
</script>

<style lang="less" scoped>
.tabs_styles {
  /deep/ .ivu-tabs-bar {
    border-bottom: none;
    background-color: #fff;
    padding: 8px 0 3px 0;
    margin: 0;
  }
}
</style>
